// @ts-nocheck
import { extend } from 'lodash';
import moment from 'moment-timezone';

import type { IntlShape } from 'react-intl';
import type { ChangeLogData } from 'sonata-static-storage/lib/common/common.types';

type TimeFrame = {
  beginDate: string;
  endDate: string;
};

export const buildTimeframe = (timeFrame: TimeFrame, timezone: string) => {
  let normTimeFrame = {};
  if (timeFrame && timeFrame.beginDate) {
    normTimeFrame = extend(normTimeFrame, {
      start:
        moment.utc(timeFrame.beginDate).format('YYYY-MM-DDT00:00:00') +
        moment(timeFrame.beginDate).tz(timezone).format('Z')
    });
  }
  if (timeFrame && timeFrame.endDate) {
    normTimeFrame = extend(normTimeFrame, {
      end:
        moment.utc(timeFrame.endDate).format('YYYY-MM-DDT23:59:59') + moment(timeFrame.endDate).tz(timezone).format('Z')
    });
  }
  return normTimeFrame;
};

export const getAttributionZoneIds = (zones: any[]): string[] => {
  const attributionZoneIds: string[] = [];
  zones.forEach(attributionZone => {
    if (attributionZone.type === 'attribution') {
      attributionZoneIds.push(attributionZone._id);
    } else if (attributionZone.type === 'attributionTorus') {
      attributionZone.torusConfig.forEach((torus: any) => {
        attributionZoneIds.push(torus.id);
      });
    }
  });
  return attributionZoneIds;
};

export const processChangeLogData = (changeLogData: ChangeLogData[] = [], user: Record<string, any>) => {
  const changeLogDataCollection = new taptap.collections.ChangeLogCollection({
    user: user.id
  });
  const userModel = new taptap.models.User(user);
  changeLogDataCollection.reset();
  changeLogData.forEach(changeLogDataEntry => {
    const newEntry = new taptap.models.ChangeLog(changeLogDataEntry);
    try {
      newEntry.formatItemData(userModel).showChange ? changeLogDataCollection.add(newEntry) : undefined;
    } catch (_err) {
      // todo nothing to do
    }
  });
  return taptap.tools.flatModel(changeLogDataCollection);
};

export const getCountriesFromCampaigns = (campaigns: Record<string, any>[]): string[] => {
  const allCountries = campaigns.map(campaign => campaign.countries);
  return [...new Set(allCountries)];
};

export const getStaticReports = (
  selectedCampaigns: Record<string, any>[],
  formatMessage: IntlShape['formatMessage']
) => {
  const selectedCampaignWithStaticReports = selectedCampaigns.find(cam => cam.staticReports.length > 0);
  const staticReports = selectedCampaignWithStaticReports?.staticReports || [];
  if (!staticReports.length) {
    return [];
  }

  const defaultCondition = (staticReport: Record<string, any>) => {
    return staticReport.reportFilters?.length === 0 && staticReport.reportTimestep === 'day';
  };

  const defaultReport = staticReports.find(defaultCondition);

  const restStaticReports = staticReports.filter(
    (staticReport: Record<string, any>) => !defaultCondition(staticReport) && Boolean(staticReport.reportTimestep)
  );

  return [
    {
      filters: defaultReport.reportFilters,
      id: defaultReport._id,
      name: formatMessage({
        defaultMessage: 'Default Reportssss',
        id: 'reportingStats.cpyStaticReportDefault'
      })
    },
    ...restStaticReports.map((report: Record<string, any>) => ({
      ...report,
      filters: report.reportFilters,
      id: report._id,
      name: report.reportFilters
        .map((filter: string) =>
          formatMessage({
            defaultMessage: filter,
            id: `reportingStats.cpyFilter${filter}`
          })
        )
        .join(' - ')
    }))
  ];
};
